<template>
    <div>
        <a-skeleton v-for="index in elementsCount" :key="index" :active="active" />
    </div>
</template>

<script>
export default {
    props: {
        elementsCount: {
            type: Number,
            required: false,
            default: parseInt(Math.random() * 2 + 4)
        },

        active: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
